import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { FilterType, Table } from "@components";
import { getAllActiveAnnouncements } from "@api/getAnnouncements";
import { Cell } from "@components/table/types";
import { M_TABLE_HEADERS_ANNOUNCEMENTS } from "../dashboard/admin/maintenance/constants";
import parse from "html-react-parser";
import { AnnouncementModel } from "@api/types/announcements";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.TITLE },
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.MESSAGE },
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.DATE_POSTED },
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.POSTED_BY },
];

export const Announcements: React.FC = () => {
  const [announcements, SetAnnouncements] = useState<AnnouncementModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getAnnouncementList();
  }, []);

  // necessary because backend stores DateTimeObjects in UTC
  // split UTC DateTimeObject between T character
  function formatDateTimeJavaString(announcementDatePosted: any): string {
    const split = announcementDatePosted.split("T");
    return split[0] + " " + split[1];
  }

  function getAnnouncementList() {
    setIsLoading(true);
    getAllActiveAnnouncements()
      .then((response: any) => {
        let dataList: any = response.announcements;
        dataList.forEach((announcement: any) => {
          let formattedDate = formatDateTimeJavaString(announcement.datePosted);
          announcement.datePosted = formattedDate;
        });
        SetAnnouncements(dataList);
      })
      .catch((error) => {
        console.error(`Error in fetching announcements ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        //setAnnouncementHooksyStore({ fetchList: false });
        //setGsapHooksyStore({ fetchList: false });
      });
  }
  const pageName = "GEARS Announcements";
  return (
    <Box mt={2}>
      <Table
        data={announcements.map((announcement: AnnouncementModel) => ({
          cells: [
            {
              data: announcement.title,
              color: "blue",
            },
            {
              data: parse(announcement.message),
            },
            {
              data: announcement.datePosted,
            },
            {
              data: announcement.postedBy,
            },
          ],
          data: announcement,
        }))}
        tableName={pageName}
        headers={headers}
        searchPlaceholder="Search by Title"
        searchColumns={[M_TABLE_HEADERS_ANNOUNCEMENTS.TITLE]}
        filters={[FilterType.SORT, FilterType.SEARCH]}
        toolbar="M_ANNOUNCEMENTS_TOOLBAR_SEARCH"
        loading={isLoading}
      />
    </Box>
  );
};
